import { PayloadAction } from '@reduxjs/toolkit';
import { put, takeLatest } from 'redux-saga/effects';
import {
  fetchPendingAllocator,
  fetchPendingAllocatorFailed,
  fetchPendingAllocatorSucceeded,
} from 'redux/slice/lenders/PendingLenders.slice';
import { AllocatorListPayload } from 'redux/types/Allocator.types';

import { ApiStatusCodes } from '../../../services/api/apiStatusCode';
import { allocator } from '../../../services/api/endPoints';
import { HTTPClient } from '../../../services/api/http-client';
import { IFetchMyAllocatorResponse } from './Allocator.types';

export function* fetchPendingAllocatorSaga({
  payload,
}: PayloadAction<AllocatorListPayload>) {
  try {
    const { agencyId } = payload;
    // Simulate API call with a 10-second delay using Redux Saga's `delay` effect
    const result: IFetchMyAllocatorResponse = yield HTTPClient.GetRequest(
      allocator.GET_PENDING_ALLOCATOR_LIST(agencyId)
    );

    const { data, status } = result;

    if (status === ApiStatusCodes.SUCCESS && data) {
      yield put(fetchPendingAllocatorSucceeded(data?.allocatorList));
    } else {
      throw new Error();
    }
  } catch (error) {
    // Handle API call failure or network errors

    yield put(
      fetchPendingAllocatorFailed({
        error: {
          message: 'An error occurred while fetching lenders.',
        },
      })
    );
  }
}

export function* watchPendingLenderSaga() {
  yield takeLatest(fetchPendingAllocator.type, fetchPendingAllocatorSaga);
}
